import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { login } from "../../stores";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Col,
  Tab,
  Row,
} from "react-bootstrap";
import Aurora from "./Aurora";

function LoginPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");

  const [cardClasses, setCardClasses] = React.useState("card-hidden");
  React.useEffect(() => {
    setTimeout(function () {
      setCardClasses("");
    }, 1000);
  });
  // const handlePrivacyLinkClick = () => {
  //   window.open("/privacy", "_blank", "noopener,noreferrer");
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    login(dispatch, { username, password }, history);
  };
  return (
    <>
      {/* <SplashCursor /> */}
      <div className="full-page section-image" data-color="black">
        <div
          className="content d-flex align-items-center p-0"
          style={{ minHeight: "100vh" }}
        >
          <Container>
            <Col className="mx-auto" lg="4" md="6" sm="10">
              <Form
                action=""
                className="form"
                method=""
                onSubmit={handleSubmit}
              >
                <Card
                  className={"card-login " + cardClasses}
                  style={{
                    borderRadius: "20px",
                    border: "none",
                    boxShadow: "0 15px 35px rgba(0,0,0,0.2)",
                    overflow: "hidden",
                    padding: "20px",
                  }}
                >
                  <Card.Header className="bg-transparent border-0 pt-4">
                    <div className="text-center mb-3">
                      {/* Icon Branding Sederhana tapi Mewah */}
                      <div
                        className="d-inline-flex align-items-center justify-content-center shadow-sm"
                        style={{
                          width: "70px",
                          height: "70px",
                          background:
                            "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                          borderRadius: "18px",
                          color: "white",
                        }}
                      >
                        <i
                          className="fas fa-shield-alt fa-2x"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            margin: 0,
                            padding: 0,
                            lineHeight: 1,
                            textAlign: "center",
                          }}
                        ></i>
                      </div>
                    </div>
                    <h3
                      className="header text-center m-0"
                      style={{
                        fontWeight: "900",
                        color: "#1e293b",
                        letterSpacing: "1px",
                      }}
                    >
                      LOGIN
                    </h3>
                    <p
                      className="text-center text-muted small mt-2 fw-600 text-uppercase"
                      style={{ letterSpacing: "1px" }}
                    >
                      Performance Monitor
                    </p>
                  </Card.Header>

                  <Card.Body className="px-4 pb-0">
                    <Form.Group className="mb-3">
                      <label className="small fw-800 text-muted text-uppercase mb-2 ml-1">
                        Username
                      </label>
                      <div
                        className="d-flex align-items-center bg-light rounded-lg px-3 border-0 shadow-none"
                        style={{
                          height: "55px",
                          borderRadius: "12px",
                          backgroundColor: "#f8fafc",
                          border: "1px solid #e2e8f0",
                        }}
                      >
                        <i className="fas fa-user-circle text-muted mr-3"></i>
                        <Form.Control
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Masukkan username"
                          type="text"
                          className="border-0 bg-transparent p-0 fw-600 shadow-none"
                          style={{ fontSize: "15px" }}
                        />
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-2">
                      <label className="small fw-800 text-muted text-uppercase mb-2 ml-1">
                        Password
                      </label>
                      <div
                        className="d-flex align-items-center bg-light rounded-lg px-3 border-0 shadow-none"
                        style={{
                          height: "55px",
                          borderRadius: "12px",
                          backgroundColor: "#f8fafc",
                          border: "1px solid #e2e8f0",
                        }}
                      >
                        <i className="fas fa-lock text-muted mr-3"></i>
                        <Form.Control
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="********"
                          type="password"
                          className="border-0 bg-transparent p-0 fw-600 shadow-none"
                          style={{ fontSize: "15px" }}
                        />
                      </div>
                    </Form.Group>
                  </Card.Body>

                  <Card.Footer className="px-4 pb-4 bg-transparent border-0 text-center">
                    <Button
                      className="btn-block py-3 border-0 fw-900 mt-2 shadow"
                      type="submit"
                      style={{
                        background:
                          "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                        borderRadius: "12px",
                        color: "white",
                        fontSize: "16px",
                        letterSpacing: "1px",
                        transition: "all 0.3s ease",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.transform = "translateY(-2px)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      SIGN IN
                    </Button>
                  </Card.Footer>
                </Card>

                {/* PRIVACY & TERMS - LEBIH CLEAN */}
                <div className="mt-4 text-center">
                  <div
                    className="d-inline-flex align-items-center justify-content-center py-2 px-4 rounded-pill"
                    style={{
                      backgroundColor: "rgba(0,0,0,0.3)",
                      backdropFilter: "blur(5px)",
                      border: "1px solid rgba(255,255,255,0.1)",
                    }}
                  >
                    <a
                      href="/auth/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white small fw-600 text-decoration-none hover-link"
                    >
                      Privacy Policy
                    </a>
                    <span className="mx-3 text-white opacity-5">|</span>
                    <a
                      href="/auth/termsandconditions"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white small fw-600 text-decoration-none hover-link"
                    >
                      Terms & Conditions
                    </a>
                  </div>
                </div>
              </Form>
            </Col>
          </Container>
        </div>

        {/* BACKGROUND DENGAN OVERLAY BIAR TEXT JELAS */}
        <div
          className="full-page-background"
          style={{
            backgroundImage:
              "url(" + require("assets/img/bgNew.jpg").default + ")",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              background: "rgba(83, 82, 82, 0.5)", // Overlay gelap agar form lebih pop-out
            }}
          ></div>
        </div>

        <style>{`
    .fw-600 { font-weight: 600; }
    .fw-800 { font-weight: 800; }
    .fw-900 { font-weight: 900; }
    .hover-link:hover { text-decoration: underline !important; color: #f90203 !important; }
    input::placeholder { color: #cbd5e1 !important; font-weight: 400; }
  `}</style>
      </div>
    </>
  );
}

export default LoginPage;
